import { useSelector } from 'react-redux';

const usePermissionCheck = () => {
    const permissions = useSelector(state => state.user.permissions);
    const checkPermission = key => permissions && permissions[key];
    return [checkPermission];
};

export default usePermissionCheck;
